import { FC, ReactNode } from 'react'
import clsx from 'clsx'

import styles from './webinar-template.module.scss'

interface ITemplateItem {
  title: string
  titleModificator?: string
  children: ReactNode
}

const TemplateItem: FC<ITemplateItem> = ({ title, titleModificator, children }) => {
  return (
    <>
      <h2 className={clsx(styles.title, { [titleModificator as string]: titleModificator })}>
        {title}
      </h2>
      <div className={styles.templateItem}>
        <div className={styles.templateText}>{children}</div>
      </div>
    </>
  )
}

export default TemplateItem
